import { ref } from 'vue'

const open = ref(false)

/** Left drawer state — shared by AppBar and Drawer. */
export function useDrawer() {
  return {
    open,
    toggle: () => (open.value = !open.value),
    close: () => (open.value = false),
    show: () => (open.value = true)
  }
}
